import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '../../helpers/api-helper';
import AccountApi from '../../../infrastructure/account-api';
export const getUsersAsync = createAsyncThunk('users/getAll', async (companyId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AccountApi.getUsers(companyId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createUserAsync = createAsyncThunk('users/create', async (user, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AccountApi.createUser(user);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateUserAsync = createAsyncThunk('users/update', async (user, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AccountApi.updateUser(user);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const disableUserAsync = createAsyncThunk('users/disableUser', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AccountApi.disableUser(request);
        //dispatch(addSuccessNotification('User disabled successfully!'));
        //const getUsersRequest = (getState() as RootState).user.getUserDetailsRequest;
        //dispatch(toggleDisableUserConfirm());
        //dispatch(getUsersAsync(getUsersRequest));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteUserAsync = createAsyncThunk('users/deleteUser', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AccountApi.deleteUser(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
